import { Button, styled } from "@mui/material";

export const BglCloseButtonBase = styled(Button)(({theme}) => ({
  backgroundColor : theme.bglPalette.data_colors.error_btn,
  borderColor : theme.bglPalette.data_colors.error_btn,
  ":hover" : {
    backgroundColor : theme.bglPalette.data_colors.error_btn,
    borderColor : theme.bglPalette.data_colors.error_btn
  }
}))

export const BglPrimaryButtonBase = styled(Button)(({theme}) => ({
  backgroundColor : theme.bglPalette.data_colors.primart_btn,
  borderColor : theme.bglPalette.data_colors.primart_btn,
  ":hover" : {
    backgroundColor : theme.bglPalette.data_colors.primart_btn,
    borderColor : theme.bglPalette.data_colors.primart_btn
  }
}))

export const BglCloseButton = (props : any) => {
  return (
    <BglCloseButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}

export const BglPrimaryButton = (props : any) => {
  return (
    <BglPrimaryButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}